import type { AxiosRequestConfig } from 'axios';
import { axiosInstance } from 'app/api/axiosInstance';

type Cfg = Omit<AxiosRequestConfig, 'url' | 'method' | 'data'>;

export const api = {
  async get<T>(url: string, config?: Cfg): Promise<T> {
    const res = await axiosInstance.get<T>(url, config);
    return res.data;
  },
  async post<TRes, TBody = unknown>(url: string, body?: TBody, config?: Cfg): Promise<TRes> {
    const res = await axiosInstance.post<TRes>(url, body, config);
    return res.data;
  },
  async patch<TRes, TBody = unknown>(url: string, body?: TBody, config?: Cfg): Promise<TRes> {
    const res = await axiosInstance.patch<TRes>(url, body, config);
    return res.data;
  },
  async put<TRes, TBody = unknown>(url: string, body?: TBody, config?: Cfg): Promise<TRes> {
    const res = await axiosInstance.put<TRes>(url, body, config);
    return res.data;
  },
  async del<TRes = void>(url: string, config?: Cfg): Promise<TRes> {
    const res = await axiosInstance.delete<TRes>(url, config);
    return res.data;
  },
};
